module.exports = __webpack_public_path__ + "img/office_dialog_icon05.3936d4c5.png";